import { Phone } from 'lucide-react';

export const FloatingCTA = () => {
  return (
    <a
      href="tel:+4915146173685"
      className="floating-cta md:hidden"
      aria-label="Jetzt Anrufen"
      data-testid="floating-phone-btn"
    >
      <Phone className="w-6 h-6" />
    </a>
  );
};
